import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { TextAlignProps } from 'styled-system';
import { space, textAlign } from 'styled-system';

import { useLocalization } from '../../providers/LocaleProvider';
import type { SpaceProps } from '../../theme/system-types';
import type { LoadButtonProps } from './LoadButton';
import LoadButton from './LoadButton';

const LoadPrevButtonWrapper = styled.div<SpaceProps & TextAlignProps>`
  ${space};
  ${textAlign};
`;

const buttonWrapperStyles: ComponentProps<typeof LoadPrevButtonWrapper> = {
  my: ['sp_16', 'sp_20', 'sp_24', 'sp_32'],
  textAlign: 'center',
};

const roundedButtonWrapperStyles: ComponentProps<typeof LoadPrevButtonWrapper> = {
  mb: ['sp_16', 'sp_20', 'sp_24', 'sp_32'],
  mt: 'sp_0',
  textAlign: 'center',
};

const LoadPrevButton = (props: LoadButtonProps) => {
  const { t } = useLocalization();

  return (
    <LoadPrevButtonWrapper
      {...(props.isRounded ? roundedButtonWrapperStyles : buttonWrapperStyles)}
    >
      <LoadButton {...props}>{t('h24_load_prev')}</LoadButton>
    </LoadPrevButtonWrapper>
  );
};

export default LoadPrevButton;
